import React from "react";
import { useLang } from "../../shared/i18n";
import AuthAmbientLayers from "./AuthAmbientLayers";

const AuthMarketingPanel: React.FC = () => {
  const { t } = useLang();

  return (
    <aside
      className="auth-marketing"
      aria-label={t("loginMktAriaLabel")}
      data-theme="light"
    >
      <AuthAmbientLayers />

      <div className="am-content">
        {/* ── Header: Typography ── */}
        <div className="am-text-content">
          <h2 className="am-h">{t("loginMktTitle")}</h2>
          <p className="am-sub">{t("loginMktSub")}</p>
        </div>

        {/* ── Abstract SVG Animation Centerpiece ── */}
        <div className="am-svg-wrapper" aria-hidden="true">
          <svg
            viewBox="0 0 400 240"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="xMidYMid meet"
          >
            {/* Left Column (Bank) */}
            <g className="ams-left-1">
              <rect
                x="20"
                y="40"
                width="130"
                height="34"
                rx="6"
                className="ams-row"
              />
              <rect
                x="36"
                y="48"
                width="60"
                height="6"
                rx="3"
                className="ams-skeleton-strong"
              />
              <rect
                x="36"
                y="60"
                width="40"
                height="4"
                rx="2"
                className="ams-skeleton"
              />
            </g>
            <g className="ams-left-2">
              <rect
                x="20"
                y="100"
                width="130"
                height="34"
                rx="6"
                className="ams-row"
              />
              <rect
                x="36"
                y="108"
                width="70"
                height="6"
                rx="3"
                className="ams-skeleton-strong"
              />
              <rect
                x="36"
                y="120"
                width="50"
                height="4"
                rx="2"
                className="ams-skeleton"
              />
            </g>
            <g className="ams-left-3">
              <rect
                x="20"
                y="160"
                width="130"
                height="34"
                rx="6"
                className="ams-row"
              />
              <rect
                x="36"
                y="168"
                width="50"
                height="6"
                rx="3"
                className="ams-skeleton-strong"
              />
              <rect
                x="36"
                y="180"
                width="30"
                height="4"
                rx="2"
                className="ams-skeleton"
              />
            </g>

            {/* Connectors & Matches */}
            {[57, 117, 177].map((cy, i) => (
              <g key={cy}>
                <line
                  x1="150"
                  y1={cy}
                  x2="250"
                  y2={cy}
                  className={`ams-line ams-line-${i + 1}`}
                />
                <circle
                  cx="150"
                  cy={cy}
                  r="3"
                  fill="var(--brand-green-500)"
                  className={`ams-dot ams-dot-${i + 1}`}
                />
                <g className={`ams-check ams-check-${i + 1}`}>
                  <circle
                    cx="200"
                    cy={cy}
                    r="8"
                    fill="var(--brand-green-500)"
                  />
                  <path
                    d={`M196 ${cy} L 199 ${cy + 3} L 205 ${cy - 3}`}
                    stroke="#fff"
                    strokeWidth="1.5"
                    fill="none"
                  />
                </g>
              </g>
            ))}

            {/* Right Column (Receipts) - Shuffles vertically */}
            <g className="ams-right-1">
              <rect
                x="250"
                y="40"
                width="130"
                height="34"
                rx="6"
                className="ams-row"
              />
              <circle cx="270" cy="57" r="8" className="ams-icon" />
              <rect
                x="286"
                y="48"
                width="50"
                height="6"
                rx="3"
                className="ams-skeleton-strong"
              />
              <rect
                x="286"
                y="60"
                width="30"
                height="4"
                rx="2"
                className="ams-skeleton"
              />
            </g>
            <g className="ams-right-2">
              <rect
                x="250"
                y="100"
                width="130"
                height="34"
                rx="6"
                className="ams-row"
              />
              <circle cx="270" cy="117" r="8" className="ams-icon" />
              <rect
                x="286"
                y="108"
                width="60"
                height="6"
                rx="3"
                className="ams-skeleton-strong"
              />
              <rect
                x="286"
                y="120"
                width="40"
                height="4"
                rx="2"
                className="ams-skeleton"
              />
            </g>
            <g className="ams-right-3">
              <rect
                x="250"
                y="160"
                width="130"
                height="34"
                rx="6"
                className="ams-row"
              />
              <circle cx="270" cy="177" r="8" className="ams-icon" />
              <rect
                x="286"
                y="168"
                width="40"
                height="6"
                rx="3"
                className="ams-skeleton-strong"
              />
              <rect
                x="286"
                y="180"
                width="20"
                height="4"
                rx="2"
                className="ams-skeleton"
              />
            </g>
          </svg>
        </div>

        {/* ── Footer: Trust Badges ── */}
        <div className="am-badges">
          <div className="am-trust-badge">
            <span className="am-badge-dot" />
            {t("loginMktBadgeMatching")}
          </div>
          <div className="am-trust-badge">
            <span className="am-badge-dot" />
            {t("loginMktBadgeSecurity")}
          </div>
          <div className="am-trust-badge">
            <span className="am-badge-dot" />
            {t("loginMktBadgeSupport")}
          </div>
        </div>
      </div>
    </aside>
  );
};

export default AuthMarketingPanel;
